<template>
  <booking-section id="checkout" :title="`Buchung abschließen`" contentClass="">
    <div class="booking__checkout" id="booking_services_table" v-if="loaded">
      <div v-html="result.checkout_view"></div>
    </div>

    <loader v-else title="Ihre Buchung wird vorbereitet" details="Einen Moment bitte"></loader>
  </booking-section>
</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'

export default {
  mixins: [resultLoader, bookingDefaults],
  watch: {
    loaded(){
      if (this.loaded == true){
        this.cartItemIds = this._.map(this.result.results, (r => r.id) )
        this.amadeusBookingId = this.result.amadeus_booking_id
        window.setTimeout(this.initCheckoutForm, 500)
      }
    }
  },
  data(){
    return {
      currentStep: 'checkout',
      selectOptions: { minimumResultsForSearch: 5, placeholder: 'Bitte wählen Sie:', options: { dropdownCssClass: 'dropdown-shadow' } },
      checkoutForm: null,
      cartItemIds: [],
      paymentMethod: null
    }
  },
  computed: {
    apiSummaryUrl(){
      return `${process.env.BASE_URL}/api/booking/${this.productId}/summary`
    },
    apiInsuranceUrl(){

    }
  },
  methods: {
    initCheckoutForm() {

      if (window.currentFormData == null){
        window.currentFormData = {}
      }else{
        Object.keys(window.currentFormData).forEach(k => {
          $(`#${k}`).val(window.currentFormData[k])
        })
      }

      $(".js-select2").select2(this.selectOptions)
      //JqAjaxCore2.Validation.initForms()
      this.checkoutForm = $('form#quick-checkout-form')

      $('.booking__passenger input, .booking__passenger select').blur(() => {
        this.updateSummary()
      })

      $('.booking__passenger input, .booking__passenger select, .booking__billing input , .booking__billing select').blur((e) => {
        $('.booking__passenger input, .booking__passenger select, .booking__billing input , .booking__billing select').each((i,f) => {
          window.currentFormData[f.id] = f.value
        })

      })

      // Form handlig for payment mode
      $("#payment > .row").on("click", (e) => {
        var currentInput = $(e.target).closest('.row').find('input[type="checkbox"], input[type="radio"]')
        var currentRow = $(e.target).closest('.row')

        if (currentInput.prop("checked") != true){
          currentInput.prop("checked", true)

          if (currentInput.attr('id') == 'payment-mode-2' || $('input[name*="payment_mode"]:checked').val() == '2'){
            $("#cardDetails").show()
          }else {
            $("#cardDetails").hide()
          }

          this.paymentMethod = currentRow[0].id
          this.gTrack("selectPayment", this.paymentMethod)

          this.updateSummary()
        }
      })

      $("a[data-coupon-id]").click((e) =>{
        $(".columns[data-coupon-id]").removeClass('selected')

        $.get($(e.target).attr('href'), function(data){
          alert(`Der gewählte Gutschein ${$(e.target).data('coupon-name')} wurde angewendet`)
          $(`.columns[data-coupon-id="${$(e.target).data('coupon-id')}"]`).addClass('selected')
        })

        return false
      })

      $('#checkout_agb_check_trigger').change(() => {
        $('#checkout_agb_check').val('1')
        $("#checkout_price_check_trigger").prop('checked', true)
      })

      $("#checkout_billing_adress_country_id").change(_ => {
        this.togglePaypal()
        this.updateSummary()
      })


      $('.reveal-overlay').remove()

      window.tocReveal = new Foundation.Reveal($("#terms_and_conditions.reveal"))

      $('#trc-submit-booking').click(_ => {
        $("label[for='checkout_travel_info_trigger'], label[for='checkout_price_check_trigger']").removeClass('error')

        if (JqAjaxCore2.Validation.validateForm(this.checkoutForm)){
          var errors = false
          if ($('#checkout_travel_info_trigger:checked').length == 0){
            $("label[for='checkout_travel_info_trigger']").addClass('error')
            errors = true
          }


          if (errors){
            this.gTrack("preSubmit:missingTerms")
            alert("Bitte bestätigen Sie die Allgemeinen Reisebedingungen.")

          } else if (this.paymentMethod == null && $("#payment").length) {
            this.gTrack("preSubmit:missingPayment")
            alert("Bitte wählen Sie eine Zahlungsmethode")
            $("#payment").get(0).scrollIntoView()
          }
          else{
            this.gTrack("preSubmit:ok")
            window.tocReveal.open()
          }

        }else{
          this.gTrack("preSubmit:withErrors")
          alert("Bitte prüfen Sie Ihre Eingaben.")
        }
      })

      $('#submit_checkout_form').click(() => {
        JqAjaxCore2.Validation.validateForm(this.checkoutForm)
        if (($('#checkout_agb_check_trigger:checked').length >= 1) && ($('#checkout_formblatt_check_trigger:checked').length >= 1)) {
          $('#terms_and_conditions').foundation('close');

          if (JqAjaxCore2.Validation.validateForm($('#quick-checkout-form'))) {

            // handle form in rails style
            var url = $('#quick-checkout-form').attr('action')
            var data = $('#quick-checkout-form :input').serializeObject()

            $('#booking-footer-loader').show()
            $('#booking-footer-content').hide()

            this.gTrack("submit:ok")

            this.handleCheckoutRoute(url, data)
          }
        }else{
          if ($('#checkout_agb_check_trigger:checked').length === 0){
            alert("Bitte bestätigen: " + $("#checkout_agb_check_trigger").attr('data-confirmation-message'))
            $("label[for='checkout_agb_check_trigger']").addClass('error')
          }

          if ($('#checkout_formblatt_check_trigger:checked').length === 0){
            alert("Bitte bestätigen: " + $("#checkout_formblatt_check_trigger").attr('data-confirmation-message'))
            $("label[for='checkout_formblatt_check_trigger']").addClass('error')
          }
          this.gTrack("submit:missingTerms")
        }

        return false
      })

      this.togglePaypal();
      $("#cardDetails").hide()

    },

    handleCheckoutRoute(url, data){
      axios.post(url, data)
      .then(response => {
        if (response.data.status == 'OK'){
          // handle different server response messages:
          if (response.data.data.result == 'CHECKOUT_COMPLETE'){
            this.fireGTAGPurchase()
            window.location = response.data.url
          }else {
            this.handleCheckoutRoute(response.data.url)
          }
        }else if (response.data.status == 'REDIRECT') {

          const statusUrl = `/cart/checkout_status/${this.result.group_hash}`

          $("#booking-footer-loader .loading-screen__title").html('Sie werden zum Zahlungsanbieter weitergeleitet')
          $("#booking-footer-loader .loading-screen__details").html(`
            <p>Bitte schließen Sie dieses Fenster nicht.</p>
            <p><a href="${response.data.url}" target="blank">Klicken Sie hier falls der Link zum Zahlungsanbieter nicht automatisch geöffnet wurde.</a></p>
          `)

          const statusLoader = setInterval(() => {
            axios.get(statusUrl)
            .then(s => {
              if (s.data.status == 'OK'){
                clearInterval(statusLoader)
                this.fireGTAGPurchase()
                $("#booking-footer-loader .loading-screen__logo").hide()
                $("#booking-footer-loader .loading-screen__title").html('Ihre Buchung war erfolgreich')
                $("#booking-footer-loader .loading-screen__details").html('Sie können dieses Fenster schließen')
              }
            })
          }, 1000)

          window.open(response.data.url)
        } else {
          alert(this.$t(`checkoutErrors.${response.data.data.result}`))
          $('#booking-footer-loader').hide()
          $('#booking-footer-content').show()
        }
      })
    },

    togglePaypal(){
      if ($("#checkout_billing_adress_country_id").val() == '58'){
        $("#paypal").show()
        $("#paypal input").attr('disabled', false)
      }else {
        $("#paypal").hide()
        $("#paypal input").attr('disabled', true)
      }
    },

    fireGTAGPurchase(){
      //if (process.env.NODE_ENV == 'development'){
      //  console.log('GTAG', 'purchase', this.result.global.ecommerce_data)
      //}else{
      //  try {
      //    gtag('event', 'purchase', this.result.global.ecommerce_data);
      //  }
      //  catch {
      //
      //  }
      //}
    },
    updateSummary () {
      var data = {
        cart_item_ids: this.cartItemIds,
        amadeus_booking_id: this.amadeusBookingId,
        checkout: {
          cart_items: $('.booking__passenger input, .booking__passenger select').serializeObject().checkout.cart_items,
          billing_adress: $('.booking__billing input, .booking__billing select').serializeObject().checkout.billing_adress
        }
      }

      var paymentMode = $('input[name*="payment_mode"]:checked');

      if (paymentMode.length && (paymentMode.val() === '2' || paymentMode.val() === '6')) {
        data.credit_card_type_id = $('#checkout_payment_data_credit_card_type_id').val()
      }

      data.payment_mode_id = paymentMode.val()

      var selectedInsurance = $('input[name="checkout[insurance_id]"]:checked');

      if (selectedInsurance) {
        data.insurance = selectedInsurance.val();
      }

      axios.post(this.apiSummaryUrl, data)
      .then(response => {
        $('#booking-price-table').html(response.data.template)

      })

    }
  },

}
</script>

<style lang="scss" scoped>

</style>
